export const mailServerUri = {
  dev: "http://localhost:8080",
  production: "https://mail.dunssweden.co.kr"
}



// WEBPACK FOOTER //
// ./src/lib/serverInfo.js